import { render, staticRenderFns } from "./SectionsTop.vue?vue&type=template&id=431b19a0"
import script from "./SectionsTop.vue?vue&type=script&lang=js"
export * from "./SectionsTop.vue?vue&type=script&lang=js"
import style0 from "./SectionsTop.vue?vue&type=style&index=0&id=431b19a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports